import api, { PaginateRequest, PaginateResponse, ResponseCallback } from '../services/api.service'
import { CaseData } from './inventoryCase.api'
import { WorkOrderData } from './workOrder.api'

export type ConsumedPaginateCaseResponse = PaginateResponse<ConsumedData<CaseData>[]>

export interface ConsumedData<ConsumableData> {
  id: number
  workOrderId: number
  palletId: number
  createdBy: number
  createdAt: string
  quantity: number | null
  isPartial: boolean
  workOrder: WorkOrderData
  consumable?: ConsumableData
}

const routes = {
  paginateCase: '/consumeds/paginateCase'
}

export default {
  paginateCase (
    params: PaginateRequest,
    callback: ResponseCallback<ConsumedPaginateCaseResponse>
  ) {
    api.get(routes.paginateCase, params, callback)
  }
}
